
/**
 * @export
 * @type SeatAssignRequest
 */
export type SeatAssignRequest = {
    state: SeatAssignRequestState;
    productSubscriptionId: string;
    /**
     * Optional audit reason. Blank values use the existing operation-specific reason.
     */
    reason?: string;
}

export enum SeatAssignRequestState {
    ASSIGN = 'ASSIGN',
    REMOVE = 'REMOVE'
}